import {ToggleScroll} from "./toggle-scroll";

/** Класс бургер-меню. */
class BurgerMenu {
    /**
     * Конструктор класса.
     *
     * @param {HTMLElement} el Элемент.
     */
    constructor(el) {
        this.el = el;
        this.btnClose = this.el.querySelector(".js-burger-close");
        this.findElements();
        this.openMenu();
        this.hideMenu();
    }

    /**
     * Поиск элементов компонента.
     *
     * @returns {void}
     */
    findElements() {
        this.btnOpen = document.querySelector(".js-show-burger-menu");
    }

    openMenu() {
        this.btnOpen.addEventListener("click", () => {
            this.el.classList.add("is-open");
            ToggleScroll.disable();
        })
    }

    hideMenu() {
        this.btnClose.addEventListener("click", () => {
            this.el.classList.remove("is-open");
            ToggleScroll.enable();
        })
    }
}

document.querySelectorAll(".js-burger-menu").forEach((el) => new BurgerMenu(el));
